import { c as _c } from "react/compiler-runtime";
import GridColumn from "@/components/common/grid-column/grid-column";
import GridRow from "@/components/common/grid-row/grid-row";
import Link, { LinkStyle, LinkType } from "@/components/common/link/link";
import { HeroOptions, Page } from "@/sanity/sanity.types";
interface IProductFooterProps {
  data: HeroOptions;
}
const CalculatorFooter = props => {
  const $ = _c(11);
  const {
    data
  } = props;
  const t0 = data?.headline;
  let t1;
  if ($[0] !== t0) {
    t1 = <h2 className="!text-white">{t0}</h2>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = data?.subhead;
  let t3;
  if ($[2] !== t2) {
    t3 = <p className="mt-2">{t2}</p>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = data?.secondaryCta?.link?.href ?? "";
  const t5 = data?.secondaryCta?.link?.label;
  let t6;
  if ($[4] !== t4 || $[5] !== t5) {
    t6 = <Link className="mx-auto mt-8" href={t4} linkType={LinkType.BUTTON} linkStyle={LinkStyle.SECONDARY}>{t5}</Link>;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t1 || $[8] !== t3 || $[9] !== t6) {
    t7 = <GridRow><GridColumn className="rounded-md bg-[#005472] px-8 py-10 text-center text-white">{t1}{t3}{t6}</GridColumn></GridRow>;
    $[7] = t1;
    $[8] = t3;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
};
export default CalculatorFooter;